import React, { useCallback, useEffect } from 'react';
import { css } from "@emotion/react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";

import SignUp from "./SignUp";
import {
    getAuthExpiry,
    hasTokenExpired,
    needEmailVerification,
    needSocialConfirmation,
} from "../../includes/auth";
import { useAppState } from "../../contexts/AppContext";
import {
    AUTH_URL,
    EMAIL_VERIFICATION_URL,
    getUrl,
    SELECT_PLAN_URL,
    SOCIAL_CONFIRMATION_URL,
} from "../../includes/pricingAuthRedirects";
import theme from "../../../theme";

const Auth = () => {
    const navigate: any = useNavigate();
    const [appState, setAppState] = useAppState();
    const location = useLocation();

    useEffect(() => {
        if (appState?.user) {
            if (needSocialConfirmation(appState?.user)) {
                navigate(getUrl(SOCIAL_CONFIRMATION_URL),
                    { state: { redirectTo: getUrl(SELECT_PLAN_URL) } }
                );
            } else if (needEmailVerification(appState?.user)) {
                if (location.pathname !== getUrl(AUTH_URL)) {
                    navigate(getUrl(EMAIL_VERIFICATION_URL),
                        { state: { redirectTo: getUrl(SELECT_PLAN_URL)} }
                    );
                }
            }
        } else if (!appState.hasConfirmedPlan) {
            navigate(getUrl(SELECT_PLAN_URL));
        }
    }, [appState, navigate, location]);

    const redirectAfterAuth = useCallback((userInfo: any) => {
        setAppState({ authorized: true });

        if (needSocialConfirmation(userInfo)) {
            navigate(getUrl(SOCIAL_CONFIRMATION_URL),
                { state: { redirectTo: getUrl(SELECT_PLAN_URL) } },
            );
        } else if (needEmailVerification(userInfo)) {
            navigate(getUrl(EMAIL_VERIFICATION_URL));
        }
    }, [navigate, setAppState]);

    // get new user data if token was passed
    useEffect(() => {
        if (!isEmpty(getAuthExpiry() && !hasTokenExpired()) && typeof appState.getUser !== 'undefined') {
            appState.getUser().then(redirectAfterAuth);
        }
    }, [appState, redirectAfterAuth]);

    return (
        <div css={authContainerStyle}>
            <SignUp redirectAfterSignUp={redirectAfterAuth} />
        </div>
    );
};

export default Auth;

const authContainerStyle = css`
    padding: 0;
    margin: 0;
    position: relative;
    display: flex;
    justify-content: center;

    ${theme.breakpoints.down('sm')} {
        width: 100%;
    }
`;